export default __webpack_public_path__ + "static/media/background-mobile.08755947.png";